// RUTA: src/hooks/useReducedMotion.ts
//
// Detecta `prefers-reduced-motion: reduce` del SO/navegador. Usuarios
// con ese setting (iOS Low Power Mode, Settings > Accessibility, etc.)
// NO deben ver animaciones decorativas — solo cambios funcionales.

import { useEffect, useState } from 'react';

export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const onChange = (e: MediaQueryListEvent) => setReduced(e.matches);
    mq.addEventListener?.('change', onChange);
    return () => mq.removeEventListener?.('change', onChange);
  }, []);

  return reduced;
}
